var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecoDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 986,
    height: 506,
    viewBox: "0 0 986 506",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M787.127 282.423L865.947 261.297L855.74 281.717L776.92 302.843L787.127 282.423Z",
    fill: "#EF0808"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.08 435.186L621.327 350.69L612.879 367.59L297.633 452.081L306.08 435.186Z",
    fill: "#E3E5F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M849.943 240.728L982.403 205.224L965.249 239.54L832.789 275.043L849.943 240.728Z",
    fill: "#E3E5F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M674.594 443.601L923.889 376.781L915.442 393.681L666.146 460.5L674.594 443.601Z",
    fill: "#051371"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M979.938 123.696L1295.18 39.1987L1286.74 56.0998L971.49 140.591L979.938 123.696Z",
    fill: "#051371"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M751.177 130.809L838.59 107.38L827.269 130.027L739.857 153.456L751.177 130.809Z",
    fill: "#C3C6E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M863.718 562.893L1178.96 478.396L1170.52 495.298L855.27 579.789L863.718 562.893Z",
    fill: "#E3E5F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M844.718 434.369L1003.52 391.808L982.95 432.949L824.154 475.512L844.718 434.369Z",
    fill: "#051371"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M868.821 312.729L1096.91 251.594L1090.8 263.822L862.709 324.957L868.821 312.729Z",
    fill: "#051371"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.485 347.52L565.892 308.015L546.803 346.203L399.4 385.711L418.485 347.52Z",
    fill: "#051371"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9401 615.794L438.864 501.365L427.419 524.252L0.5 638.682L11.9401 615.794Z",
    fill: "#EF0808"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M586.385 233.479L907.547 147.397L886.75 189.001L565.59 275.082L586.385 233.479Z",
    fill: "#EF0808"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M529.566 498.581L662.027 463.077L644.873 497.395L512.418 532.898L529.566 498.581Z",
    fill: "#C3C6E2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.761 556.977L416.113 497.647L408.612 512.653L187.26 571.983L194.761 556.977Z",
    fill: "#C3C6E2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M579.291 394.434L709.833 359.444L703.724 371.667L573.182 406.657L579.291 394.434Z",
    fill: "#EF0808"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M835.734 51.8183L1028.84 0.0639648L1003.83 50.0897L810.729 101.844L835.734 51.8183Z",
    fill: "#051371"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M966.368 419.579L1096.91 384.589L1090.8 396.811L960.26 431.801L966.368 419.579Z",
    fill: "#E3E5F2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M948.189 58.7083L1107.97 15.8818L1100.49 30.8414L940.711 73.6679L948.189 58.7083Z",
    fill: "#E3E5F2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M930.001 525.818L1158.09 464.683L1151.98 476.911L923.887 538.046L930.001 525.818Z",
    fill: "#EF0808"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M814.763 194.275L965.181 153.959L961.15 162.023L810.732 202.339L814.763 194.275Z",
    fill: "#051371"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M458.751 243.53L609.169 203.213L605.137 211.277L454.717 251.594L458.751 243.53Z",
    fill: "#C3C6E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoDesktop);
export default __webpack_public_path__ + "static/media/deco-desktop.fc677e407ddc7e50afc2fe2c092cdba3.svg";
export { ForwardRef as ReactComponent };